import PropTypes from 'prop-types';

import styles from './styles/styles.module.css';

function OutlineButton({
  text,
  onClick,
  iconLeft,
  iconRight,
  disabled,
  width,
  height,
  fontSize,
  fontWeight,
}) {
  return (
    <button
      className={styles.outlineButton}
      onClick={onClick}
      disabled={disabled}
      type="button"
      style={{
        width: width || 'auto',
        height: height || 'auto',
        fontSize: fontSize || 'inherit',
        fontWeight: fontWeight || 'inherit',
      }}
    >
      {iconLeft && <img src={iconLeft} alt="" />}
      {text}
      {iconRight && <img src={iconRight} alt="" />}
    </button>
  );
}

export default OutlineButton;

OutlineButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  iconLeft: PropTypes.string,
  iconRight: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
